import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empresas-seguras',
  templateUrl: './empresas-seguras.component.html',
  styleUrls: ['./empresas-seguras.component.css']
})
export class EmpresasSegurasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
